import { ProductTypeNames } from '@zg-rentals/rental-revenue-components';
import { ClientAdProductType, CustomerAnalyticsListingFilterType } from '@zg-rentals/ts-customer-analytics-client';
import { capitalize } from '@zg-rentals/zdash';

const AnalyticsFilterTypeNames: Partial<Record<CustomerAnalyticsListingFilterType, string>> = {
  [CustomerAnalyticsListingFilterType.TIER3]: 'Bonus Listing',
  [CustomerAnalyticsListingFilterType.TIER2_OVER_25]: 'Claimed (<25 units)',
  [CustomerAnalyticsListingFilterType.TIER2_UNDER_25]: 'Claimed (25+ units)',
};

export const mapPackageTypeName = (
  productType: ClientAdProductType | null,
  analyticsFilterType?: CustomerAnalyticsListingFilterType | null,
) => {
  switch (true) {
    case productType === ClientAdProductType.FLAT_FEE || productType === ClientAdProductType.PAY_PER_LEAD:
      return 'Rent Connect';
    case !!productType && !!ProductTypeNames[productType]: {
      const productTypeName = ProductTypeNames[productType];

      if (productTypeName.includes('Rent Connect')) return 'Rent Connect';
      if (productTypeName.includes('Feed Connect')) return 'Feed Connect';

      return productTypeName;
    }
    case !!analyticsFilterType && !!AnalyticsFilterTypeNames[analyticsFilterType]:
      return AnalyticsFilterTypeNames[analyticsFilterType];
    default:
      return capitalize(productType?.toString()?.toLowerCase() || 'unknown');
  }
};
